import { ProductCarousel } from '@/components/cells';
import { HttpTypes } from '@medusajs/types';

export const GalleryCarousel = ({
  images,
}: {
  images: HttpTypes.StoreProduct['images'];
}) => {
  return (
    <div className='w-full'>
      <ProductCarousel slides={images} />
    </div>
  );
};
